import styled from "styled-components";
import { Button as ButtonPrimitive } from "@sonder/ui/source/styled/primitives/Button";
import { borders, colors } from "@sonder/ui/source/styled/theme";

export const CheckInCheckOutBlock = styled.div`
  background: #f3f3f3;
  border: ${borders.standard};
  border-radius: 0.3rem;
`;

export type RelatedTasksStatus =
  | "archived"
  | "canceled"
  | "complete"
  | "inprogress"
  | "late"
  | "ready"
  | "unassigned";

export interface RelatedTasksBlockProps {
  isSelected?: boolean;
  isSelecting?: boolean;
  status: RelatedTasksStatus;
}

export const SchedulerTextColors = {
  archived: colors.gray1,
  canceled: colors.gray1,
  complete: colors.gray1,
  inprogress: colors.grayF,
  late: colors.grayF,
  ready: colors.grayF,
  unassigned: colors.grayF,
  waiting: colors.grayF,
};

export const SchedulerHighlightColors = {
  archived: colors.gray6,
  canceled: colors.gray6,
  complete: colors.gray6,
  inprogress: colors.white,
  late: colors.white,
  ready: "#c4f0e5",
  unassigned: colors.white,
  waiting: colors.black,
};

export const SchedulerColors = {
  archived: "#cdd7d7",
  canceled: "#cdd7d7",
  complete: "#cdd7d7",
  inprogress:
    "linear-gradient(135deg, #073937 25%, #39615f 25%, #39615f 50%, #073937 50%, #073937 75%, #39615f 75%, #39615f 100%)",
  late: "#e47c02",
  ready: "#39615f",
  unassigned: "#f9be25",
  waiting:
    "linear-gradient(135deg, #aa9e5e 25%, #f9be25 25%, #f9be25 50%, #aa9e5e 50%, #aa9e5e 75%, #f9be25 75%, #f9be25 100%)",
};

export const SchedulerShadows = {
  archived: "#9cb0af",
  canceled: "#9cb0af",
  complete: "#9cb0af",
  inprogress: "#073937",
  late: "#fc5d2b",
  ready: "#073937",
  unassigned: "#cb9c23",
  waiting: "#aa9e5e",
};

export const RelatedTaskBlock = styled(ButtonPrimitive)<RelatedTasksBlockProps>`
  align-items: center;
  background: ${props => SchedulerColors[props.status]};
  background-size: 56.57px 56.57px;
  border-radius: 0.3rem;
  box-shadow: inset 0 -0.25rem 0 ${props => SchedulerShadows[props.status]};
  display: flex;
  justify-content: flex-start;
  opacity: ${props => props.isSelecting && (props.isSelected ? 1 : 0.5)};
  padding: 0.5rem;

  &:hover {
    opacity: ${props => props.isSelecting && (props.isSelected ? 1 : 0.75)};
  }
`;

export const StackedSchedules = styled.div`
  min-height: 3.14rem;
  position: relative;
  width: 100%;

  .react-grid-layout {
    position: absolute;
  }
`;

export const ScheduleBounds = styled.div`
  border: ${borders.standard};
  border-top: 0;
  border-bottom: 0;
  box-sizing: border-box;
  cursor: pointer;
  height: 100%;
  position: absolute;
  pointer-events: none;
  transition: background 100ms linear, opacity 100ms linear;
  width: 100%;
`;

export const ScheduleBoundingParent = styled.div`
  height: 100%;
  overflow: hidden;
  position: absolute;
  pointer-events: none;
  width: 100%;
`;
